import React from 'react';

import NewsPreview from 'src/components/NewsPreview';
import ArticlePostModel from 'src/types/article/ArticlePostModel';
import styles from './styles.module.scss';

interface Props {
    items: ArticlePostModel[];
    isColumn?: boolean;
    isInList?: boolean;
}

const FeaturedFromOthersCards = ({ items, isColumn, isInList }: Props) => {
    if (!items || !items.length) {
        return null;
    }

    return (
        <div className={`${styles.container} ${isColumn ? styles.column : styles.row} ${isInList ? styles.inList : ''}`}>
            {items.map((item) => (
                <NewsPreview
                    key={`featured-from-others-${item.articleId}`}
                    className={isColumn ? styles.cardItem : styles.cardItemInRow}
                    item={item}
                    type="column_normal"
                />
            ))}
        </div>
    );
};

FeaturedFromOthersCards.defaultProps = {
    isColumn: false,
    isInList: false,
};

export default FeaturedFromOthersCards;
